module.exports = __webpack_public_path__ + "img/tertiary_6x4_z18.ead255d5.svg";